import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAsusComponent } from './simple-icons-asus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAsusComponent ],
    exports:      [ SimpleIconsAsusComponent ],
    bootstrap:    []
})
export class SimpleIconsAsusModule {}
